import {APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {environment} from '../environments/environment';
import {NgxsModule} from '@ngxs/store';
import {NgxsLoggerPluginModule} from '@ngxs/logger-plugin';
import {NgxsReduxDevtoolsPluginModule} from '@ngxs/devtools-plugin';
import {NgxsEmitPluginModule} from '@ngxs-labs/emitter';
import {SharedModule} from './shared/shared.module';
import {ApiModule as FrontendDataApiModule} from 'frontend-data-api/api.module';
import {ApiModule as FrontendFlowApiModule} from 'frontend-flow-api/api.module';
import {Configuration as DataApiConf} from 'frontend-data-api/configuration';
import {Configuration as FlowApiConf} from 'frontend-flow-api/configuration';
import {DataState} from './store/data.state';
import {LOCAL_STORAGE_ENGINE, NgxsStoragePluginModule, StorageOption} from '@ngxs/storage-plugin';
import {AuthInterceptor} from './core/authHeaders.interceptor';
import {NgxsRouterPluginModule} from '@ngxs/router-plugin';
import {registerLocaleData} from '@angular/common';
import cs from '@angular/common/locales/cs';
import {RippleModule} from "primeng/ripple";
import * as Sentry from "@sentry/angular";
import {Router} from "@angular/router";
import {DataErrorInterceptor} from "./core/data-error.interceptor";

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

registerLocaleData(cs);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FrontendDataApiModule.forRoot(() => new DataApiConf({basePath: environment.apiUrl})),
    FrontendFlowApiModule.forRoot(() => new FlowApiConf({basePath: environment.apiUrl})),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      defaultLanguage: environment.locale
    }),
    NgxsModule.forRoot([DataState], {
      developmentMode: !environment.production,
      selectorOptions: {
        suppressErrors: false,
        injectContainerState: false
      },
      compatibility: {
        strictContentSecurityPolicy: true
      }
    }),
    NgxsLoggerPluginModule.forRoot({disabled: environment.production}),
    NgxsEmitPluginModule.forRoot(),
    NgxsStoragePluginModule.forRoot({
      key: [
        'whitebricks.token',
        'whitebricks.flowId',
        'whitebricks.flowProperties.properties',
        'whitebricks.selectedAccount',
        {
          key: 'whitebricks.language',
          engine: LOCAL_STORAGE_ENGINE
        },
        {
          key: 'whitebricks.sessions',
          engine: LOCAL_STORAGE_ENGINE
        }
      ],
      storage: StorageOption.SessionStorage
    }),
    NgxsRouterPluginModule.forRoot(),
    NgxsReduxDevtoolsPluginModule.forRoot(),
    SharedModule,
    RippleModule
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: DataErrorInterceptor, multi: true},
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false
      })
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
